import React from "react";
import LegalLayout, { LegalBlock } from "@/components/legal/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      title="Terms of Service"
      seoTitle="Terms of Service | ETAP"
      description="The terms for using ETAP: what the service does, your responsibilities, the flat 0.5 percent fee, and the non custodial nature of the product."
      path="/terms"
      lastUpdated="To be confirmed by counsel"
      intro="This template sets out the terms for using ETAP. Final language will be confirmed by counsel before launch."
    >
      <LegalBlock heading="The service">
        <p>
          ETAP detects income on the accounts you select and routes the percentage you choose toward federal and state
          estimated taxes. ETAP does not file taxes on your behalf and does not provide tax, legal, or accounting
          advice.
        </p>
      </LegalBlock>
      <LegalBlock heading="Non custodial">
        <p>
          ETAP never holds your funds and is not a bank or custodian. Money moves from your linked account to tax
          authorities through authorized payment rails. Payment movement is authorized through Stripe.
        </p>
      </LegalBlock>
      <LegalBlock heading="Your responsibilities">
        <p>
          You choose your percentages and confirm which accounts to track. You are responsible for the amounts you
          route and for meeting your own tax obligations. Placeholder for eligibility and acceptable use, to be
          confirmed.
        </p>
      </LegalBlock>
      <LegalBlock heading="Fees">
        <p>
          ETAP charges a flat 0.5 percent of each routed amount, computed per transaction and enforced as a hard ceiling
          in code. There is no monthly fee and no setup fee. For agency referred users the 0.5 percent is split evenly
          between the referring agency and the platform, and you never pay more than 0.5 percent.
        </p>
      </LegalBlock>
      <LegalBlock heading="Consent and cancellation">
        <p>
          No money moves without your recorded consent. You can pause routing, change your percentages, or withdraw
          consent at any time, and withdrawal takes effect immediately.
        </p>
      </LegalBlock>
      <LegalBlock heading="Disclaimers and liability">
        <p>Placeholder for warranty disclaimers and limitation of liability, to be confirmed by counsel.</p>
      </LegalBlock>
      <LegalBlock heading="Contact">
        <p>
          Questions about these terms can be sent to{" "}
          <a href="mailto:legal@etaptax.com" className="font-semibold text-etap-primary underline underline-offset-2">
            legal@etaptax.com
          </a>
          .
        </p>
      </LegalBlock>
    </LegalLayout>
  );
}
